import React from 'react';
import PropTypes from 'prop-types';

// Base
import Card from '../../../../base/card';
import Col from '../../../../base/col';
import Row from '../../../../base/row';

export default class Sidebar extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    personas: PropTypes.array.isRequired,
    currentPersonaId: PropTypes.number,
    onPersonaChange: PropTypes.func.isRequired,
  }

  state = {
    loading: true,
  }

  render() {
    const { personas, onPersonaChange, currentPersonaId } = this.props;

    return (
      <React.Fragment>
        {
          personas.length > 1 &&
          <Card {...{
            border: 'thin',
            className: 'min-height-50 vertical-align margin-bottom-10',
            onClick: () => onPersonaChange(),
            isSelected: !currentPersonaId,
            hoverable: !!currentPersonaId,
          }} >
            ALL
          </Card>
        }
        {
          personas.map((persona) => (
            <Card {...{
              key: persona.id,
              border: 'thin',
              className: 'min-height-50 vertical-align margin-bottom-10',
              onClick: () => onPersonaChange(persona.id),
              isSelected: currentPersonaId === persona.id || personas.length === 1,
              hoverable: currentPersonaId !== persona.id,
            }}>
              <Row nested>
                <Col s={12}>
                  {persona.name || 'Default'}
                </Col>
                <Col s={12}>

                </Col>
              </Row>
            </Card>
          ))
        }
      </React.Fragment>
    )
  }
}